/** HTTP status 명명. caller 가 분기 조건에서 매직넘버 대신 사용. */
export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  SERVICE_UNAVAILABLE: 503,
  SERVER_ERROR_MIN: 500,
} as const;
